import { render, staticRenderFns } from "./OrderStore.vue?vue&type=template&id=168fd0b0"
import script from "./OrderStore.vue?vue&type=script&lang=js"
export * from "./OrderStore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports